import React from 'react'
import type { StartLabelTextFieldProps } from '@edge/spark/feature-mui-rhf-inputs'
import { StartLabelTextField } from '@edge/spark/feature-mui-rhf-inputs'

export const TextField: React.VFC<StartLabelTextFieldProps> = (props: StartLabelTextFieldProps) => {
    return <StartLabelTextField fullWidth variant="standard" {...props} />
}
